import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@gearbox-protocol/deploy-tools-ui";
import { useAuth } from "api";
import type { FC } from "react";

const AdminMenu: FC = () => {
  const { user, signIn, signOut } = useAuth();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="link"
          size="sm"
          className="gap-x-2 px-0 text-slate-400 hover:text-slate-200"
        >
          {user && (
            <span className="inline-block h-2 w-2 rounded-full bg-green-500" />
          )}
          Admin access
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-64">
        {user ? (
          <>
            <DropdownMenuLabel className="flex flex-col gap-y-1">
              <span>{user.username ?? "Connected"}</span>
              <span className="font-mono text-xs font-normal text-muted-foreground break-all">
                {user.address}
              </span>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={signOut}>Sign out</DropdownMenuItem>
          </>
        ) : (
          <DropdownMenuItem onClick={signIn}>
            Sign in with Ethereum
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AdminMenu;
